import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';

import httpClient from 'utils/httpClient';
import { Session } from './type';

const UPDATE_SESSION = (sessionId: number) =>
  `/v2/teacher/edit-unit/${sessionId}`;

export type UpdateSession = {
  duration: number;
  occurredAt: string;
  sessionId: number;
};
export type UpdateSessionResponse = {
  session: Session;
};
export const updateSession = ({
  duration,
  occurredAt,
  sessionId,
}: UpdateSession) => {
  const body = { duration, occurred_at: occurredAt };

  return httpClient.post<UpdateSessionResponse>(
    UPDATE_SESSION(sessionId),
    body,
  );
};
export const useUpdateSession = (
  opts: UseMutationOptions<
    AxiosResponse<UpdateSessionResponse>,
    AxiosError<any>,
    UpdateSession
  >,
) =>
  useMutation<
    AxiosResponse<UpdateSessionResponse>,
    AxiosError<any>,
    UpdateSession
  >(updateSession, opts);
